export const convertDateToYyyyMmDd = (isoDateString) => {
  if (!isoDateString) return;
  const date = new Date(isoDateString);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}`;
};
